import { IMapInstance, IMapMarker, LatLng, MarkerOptions } from "../map-provider.interface";
import { NoneMarker } from "./none-marker";

export class NoneMapInstance implements IMapInstance {
    // ---------------------------------------------
    // Marker APIs
    // ---------------------------------------------
    async addMarkerAsync(coords: LatLng, options?: MarkerOptions): Promise<IMapMarker> {
        return new NoneMarker();
    }

    removeMarker(marker: IMapMarker): void {
        // no-op
    }

    clearMarkers(): void {
        // no-op
    }

    // ---------------------------------------------
    // Routing / Overlays APIs
    // ---------------------------------------------
    async drawRouteAsync(origin: LatLng, destination: LatLng): Promise<void> {
        return;
    }

    // ---------------------------------------------
    // Info window APIs
    // ---------------------------------------------

    openInfo(anchor: IMapMarker, html: string | HTMLElement): void {
        // no-op
    }

    closeInfo(): void {
        // no-op
    }

    // ---------------------------------------------
    // Viewport / Camera APIs
    // ---------------------------------------------
    setCenter(coords: LatLng): void {
        // no-op
    }

    getZoom(): number {
        return 0;
    }

    setZoom(zoom: number): void {
        // no-op
    }

    isInView(coords: LatLng): boolean {
        return true;
    }

    resize(): void {
        // no-op
    }

    // ---------------------------------------------
    // Events
    // ---------------------------------------------
    onIdle(_handler: () => void): void {
        // no-op
    }
}